import styled from 'styled-components';
export const SearchPageMain = styled.section`
    padding-top: 50px;
    background: #F1FEFF;
    padding-bottom:60px; 

    @media screen and (max-width: 1024px){ 
        padding-top: 178px;
    }

    @media screen and (max-width: 991px){
        padding-top: 185px;
        padding-bottom:50px;
    }
`;

export const CityListName = styled.div`
    width: 100%;

    @media screen and (max-width: 991px){
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column; 
        gap: 20px;
        margin-bottom: 50px;
    }

    @media screen and (max-width: 767px){
        flex-direction: inherit;
        flex-wrap: wrap;
    }

    .city-box-main{
        @media screen and (max-width: 991px){
            width: 100%;
            margin-bottom: 0px;
        }
        @media screen and (max-width: 767px){
            width: calc(50% - 10px);
        }
        @media screen and (max-width: 480px){
            width: 100%;
        }
    }
`;

export const FindNonprofitBlock = styled.div`
    max-width: 851px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 15px 10px;

    .dropdown{
        button{
            min-width: 200px;
            text-align: left;
            &::after{
                position: absolute;
                right: 20px;
            }
        }
        // .dropdown-menu{
        //     margin-left: -130px;
        // }
    }  

    .loader{
    .loading{
           left: 304px !important;
          top: 136px;
    }
    
    }
`;

export const FindProfitTitle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    @media screen and (max-width: 479px){
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        row-gap: 10px;
    }

    .dropdown {
        // .dropdown-menu{
        //     margin-left: -96px;
        // }
    }
`;

export const FindProfitTitleText = styled.div`
    color: #01606F;
    font-size: 40px;
    line-height: 58px;
    font-family: "Jost", sans-serif;
    font-weight: 700;

    @media screen and (max-width: 1024px){
        font-size: 36px;
        line-height: 54px;
    }

    @media screen and (max-width: 991px){
        font-size: 32px;
        line-height: 50px;
    }
    
    @media screen and (max-width: 767px){
        font-size: 30px;
        line-height: 46px;
    }

    @media screen and (max-width: 575px){
        font-size: 24px;
        line-height: 36px;
    }
`;

export const SearchCardWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    row-gap: 15px;
`;

export const CharitiesWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    background: #fff;
    padding: 20px;
    border-radius: 15px;
    margin-top: 50px;

    @media screen and (max-width: 991px){
        margin-top: 40px;
    }
    
    @media screen and (max-width: 767px){
        margin-top: 30px;
    }
`;

export const CharitiesOther = styled.div`
    width: 100%;
`;

export const CharityTitle = styled.div`
    color: #333333;
    font-size: 20px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 25px;

    @media screen and (max-width: 767px){
        margin-bottom: 20px;
    }
`;

export const CharityDetailText = styled.div`
    color: #333333;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 22px;
    margin-bottom: 15px;
    &:last-child{
        margin-bottom: 0px;
    }
`;

export const BrowseStateCityWrap = styled.div`
    width: 100%;
    margin: 70px 0 0px;

    @media screen and (max-width: 991px){
        margin: 40px 0px 0px;
    }
    @media screen and (max-width: 767px){
        margin: 30px 0px 0;
    }

    .browse-state-button-group{
        display: none;
    }
`;

export const BrowseStateCityTitle = styled.h2`
    color: #333333;
    font-size: 20px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 20px;
`;

export const BrowseNameWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 12px;
    color: #33A7AE;

    @media screen and (max-width: 575px){
        flex-direction: column;
    }
`;

export const BrowseNameTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  font-family: "Jost", sans-serif;
  line-height: 26px;
  width: 140px;
  min-width: 140px;
`; 

export const BrowseNameDash = styled.div`
    font-size: 20px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 26px;

    @media screen and (max-width: 575px){
        display: none;
    }
`;

export const BrowseButtonGroup = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 8px;

    @media screen and (max-width: 991px){
        overflow-x: scroll;
    }

    @media screen and (max-width: 575px){
        margin-top: 10px;
    }
`;
export const BrowseButton = styled.button`
    min-width: max-content;  
    color: #33A7AE;
    font-size: 18px;
    font-weight: 400;
    font-family: "Jost", sans-serif;
    line-height: 26px;
    border: none;
    background: #fff;
    padding: 0 4px;
    transition: all 0.2s ease-in-out;
    &:hover{
        color: #F7931E;
    }
`;

export const BrowseCityListWrap = styled.div`
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 80px;

    @media screen and (max-width: 767px){
        column-gap: 50px;
    }
    @media screen and (max-width: 767px){
        gap: 20px 30px;
    }
    @media screen and (max-width: 575px){
        flex-wrap: wrap;
    }
`;

export const BrowseCityList = styled.div`
    width:100%;
    
    @media screen and (max-width: 575px){
        width: calc(50% - 20px);
    }
`;

export const BrowseCityView = styled.div`
    color: #000;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 400;
    line-height: 24px;
    cursor: pointer;
    padding: 5px 0;
    width: calc(25% - 15px);
    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 20px;
        padding: 4px 0;
       width: 100%;
    }
`;

export const BrowseViewButtonGroup = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 10px;
    margin-top: 4px;
`;

export const ViewAllButton = styled.button`
    color:#33A7AE;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 24px;
    background:transparent;
    border: none;
    padding: 0px;
    transition: all 0.2s ease-in-out;
    &:hover{
        color: #F7931E;
    }

    @media screen and (max-width: 767px){
        font-size: 16px;
        line-height: 20px;
        text-align: left;
    }
`;

export const PaginationWrap = styled.div`
    margin: 0 auto;
  .pagination{
    padding-bottom:0;
    background: transparent;
    padding-top: 30px;
  }
`;

export const TopTopicWrap = styled.div`
    width: 100%;
    margin-top: 20px;
    background: #fff;
    border-radius: 20px;

    @media screen and (max-width: 991px){
        width: calc(50% - 10px);
        margin-top: 0;
    }
    @media screen and (max-width: 767px){
        border-radius: 15px;
    }

    @media screen and (max-width: 575px){
        width: 100%;
    }

    img{
        width: 100%;
        border-radius: 20px;
        display: block;
        min-width: 100%;
        cursor: pointer;

        @media screen and (max-width: 767px){
            border-radius: 15px; 
        }
    }
.hot-topic-img {
    height: 160px;
    object-fit: cover;
}

`;

export const TopTopicTitle = styled.h3`
    width: 100%;
    color: #083F44;
    font-size: 16px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 24px;
    margin-bottom: 10px;
    text-transform: uppercase;
`;

export const TopTopicSubTitle = styled.h4`
    width: 100%;
    color: #333333;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 500;
    line-height: 30px;
    margin-bottom: 18px;
`;

export const RatingDetailBox = styled.div`
    width: 100%;
    margin: 0 auto;
    padding: 15px;
    background: #F2F2F2;
    border-radius: 8px;
    overflow: hidden;
    span{
        display: none;
    }
    img{
        max-width: 14px;
        min-width: auto;
    }
`;

export const RatingText = styled.div`
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    font-family: "Jost", sans-serif;
    line-height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 4px;
    margin-top: 12px;
`;

export const RatingBoldText = styled.strong`
    color: #333333;
    font-size: 14px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    display: block;
`;

export const RatingContentText = styled.div`
    color: rgb(51 51 51 / 80%);
    font-size: 12px;
    font-weight: 400;
    font-family: "Jost", sans-serif;
    line-height: 20px;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 2px solid #b5b5b5;
`;

export const RatingContentTextButton = styled.button`
    border: none;
    color: rgb(51 51 51 / 80%);
    font-size: 12px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 20px;
    padding-left:0;
    cursor: pointer;
`;

export const HotTopicHeading = styled.div`
    width: 100%;
    display: flex;
`;
export const HotTopicTitle = styled.h3`
    color: #083F44;
    font-size: 20px;
    font-weight: 700;
    font-family: "Jost", sans-serif;
    line-height: 30px;
    margin-bottom: 20px;  
`;

export const SideDetailView = styled.div`
    width: 100%;
    @media screen and (max-width: 991px){
        margin-top: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 20px;
    }
    .get-our-latest-news-wrap {
        @media screen and (max-width: 991px){
            width: calc(50% - 10px);
        }
        @media screen and (max-width: 575px){
            width: 100%;
            margin-bottom: 0;
            margin-top: 0;
        }
    }
    .non-profit-message{
        
        @media screen and (max-width: 991px){
            width: calc(50% - 10px);
            min-width: inherit;
        }
        
        @media screen and (max-width: 575px){
            width: 100%;
        }   
    }

    .latest-news-in-container{
        @media screen and (max-width: 991px){
            margin-top: 0px;
        }
    }
`;

export const HotTopicGroup = styled.div`
    &.hot-topic-group-main {
        margin-top: 20px;
        @media screen and (max-width: 991px){
            width: calc(50% - 10px);
            margin-top: 0px;
        }

        @media screen and (max-width: 767px){
            margin-top: 20px;
        }

        @media screen and (max-width: 575px){
            width: 100%;
        }
    }
`;

export const TopTopicInner = styled.div`
    background: #fff;
    width: 100%;
    border-radius: 20px;
    padding: 15px 20px 20px;
`;
export const CityListNew = styled.div`
   display: flex;
    flex-wrap: wrap;
   
`;

export const NoOpening=styled.div`
  img{
    width:100%;
  }
`;

export const NoOpeningTitle=styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:24px;
    font-weight: 700;
    line-height: 75px;
    margin-bottom: 0px;
    text-align: center;
`;

export const NoOpeningImage=styled.div`
    img{
        display: block;
        margin: 0 auto;
    }
`;


export const SearchNoSection=styled.div`
    text-align: center;
`;

export const SearchNoPara=styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:16px;
    font-weight: 400;
    line-height: 25px;
    margin-bottom: 5px;
`;


